/*---------------------------------------------------------*\
 * RegionSelectionController
\*---------------------------------------------------------*/
class RegionSelectionController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor() {
    this.name = 'regionSelection';
  }

  select(region) {
    this.selected = region;
    this.onSelect({
      region
    });
  }

  keyDown(event, region, index) {
    this.onKeydown({
      event,
      region,
      index
    });
  }
}

export default RegionSelectionController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/regionSelection/regionSelection.controller.js
 **/